/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, October 5th 2021, 7:45:21 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import Stack from "@mui/material/Stack";
import { alpha } from "@mui/material/styles";
import { SearchInputWidget, AdditionalSearchProps } from "ui-widgets/search/SearchInputWidget";

/**
 *
 */
import pluralize from "pluralize";
import React from "react";
/**
 *
 */

interface DataTableToolbarProps {
  numSelected: number;
  title: string;
  unit?: string;
  extraSearchProps?: AdditionalSearchProps;
  handleRefreshList?: () => void;
  extraTools?: React.ReactNode;
}

export const DataTableToolbar = (props: DataTableToolbarProps) => {
  const { numSelected, unit } = props;
  const [showSearch, setShowSearch] = React.useState<boolean>(true);
  // eslint-disable-next-line
  const toggleShowSearch = () => setShowSearch(!showSearch);

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        }),
      }}
      className="os-custom-toolbar"
    >
      {numSelected > 0 ? (
        <Typography sx={{ flex: "1 1 100%" }} color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      ) : null}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Stack direction="row" spacing={2}>
          <SearchInputWidget
            showSearch={showSearch}
            extraSearchProps={props.extraSearchProps}
            placeholder_text={unit ? `Search ${pluralize(unit)}` : ""}
          />
          {props?.extraTools}
          {/* <Tooltip title="Filter">
            <IconButton onClick={toggleShowSearch}>
              <FilterListIcon />
            </IconButton>
          </Tooltip> */}
          {props.handleRefreshList && (
            <Tooltip title="Refresh">
              <IconButton onClick={props.handleRefreshList}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      )}
    </Toolbar>
  );
};
